<svg:g [attr.visibility]="visible && isActiveLayerValid ? 'visible' : 'collapse'" (window:resize)="onResize()">
  <ng-content></ng-content>
</svg:g>
